"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useActionItemState = exports.useActionItem = void 0;
var _plateCommon = require("@udecode/plate-common");
var _plateList = require("@udecode/plate-list");
/* these hooks do not exist in v36 so they were built from scratch - in later versions the t*do list is a list item so it behaves differently
 *  this action will simply just toggle the block between a paragraph and an action_item type
 * */

var useActionItemState = function useActionItemState() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$nodeType = _ref.nodeType,
    nodeType = _ref$nodeType === void 0 ? _plateList.ELEMENT_TODO_LI : _ref$nodeType;
  var pressed = (0, _plateCommon.useEditorSelector)(function (editor) {
    return !!editor.selection && (0, _plateCommon.someNode)(editor, {
      match: {
        type: (0, _plateCommon.getPluginType)(editor, nodeType)
      }
    });
  }, [nodeType]);
  return {
    nodeType: nodeType,
    pressed: pressed
  };
};
exports.useActionItemState = useActionItemState;
var useActionItem = function useActionItem(state) {
  var editor = (0, _plateCommon.useEditorRef)();
  return {
    props: {
      onClick: function onClick() {
        (0, _plateCommon.toggleNodeType)(editor, {
          activeType: 'action_item',
          inactiveType: 'paragraph'
        });
      },
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
      },
      pressed: state.pressed
    }
  };
};
exports.useActionItem = useActionItem;